<template>
  <div>
    <div>
      <div class="row my-4 mx-1 justify-content-center">
        <v-container v-if="progress" type="image" class="loding">
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-container>
        <div v-else class="col-lg-8 col-sm-12 col-md-10 borderPointier">
          <div class="background-white">
            <div class="title">
              <div class="position">{{ $t("conditions_technique") }} </div>
            </div>
          </div>
          <form @submit.prevent="chauffe_eau_thermodynamiquesAdd">
            
        
          <b-form-group
            :label="$t('type_installation')"
            label-for="select-type_installation"
          
          >
            <b-form-select
              v-model="chauffe_eau_thermodynamiquesData.type_installation"
              :options="typeInstallationOptions"
              id="select-type_installation"
              class="custom-input"
            >
            </b-form-select>
          </b-form-group>
            <div class="fieldset mb-2" >
              <div class="legend mb-2">
                {{ $t("COP") }}   <span class="text-danger">*</span> 
              </div>
              <b-form-input
                type="number"
                min="0"
                @keydown="(event) => onKeyDown(event)"
    @paste="(event) => onPaste(event, 'chauffe_eau_thermodynamiquesData.cop')"
                v-model="chauffe_eau_thermodynamiquesData.cop"
                :placeholder="$t('COP')"
                class="form-input custom-placeholder custom-input"
              >
              </b-form-input>
            </div>
            
            <!-- Champs contact sur site -->
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("Contact sur site") || "Contact sur site" }}
              </div>
              <b-form-input
                type="text"
                v-model="contactSurSite"
                :placeholder="$t('Contact sur site') || 'Contact sur site'"
                class="form-input custom-placeholder custom-input"
                @input="updateContactSurSite"
              />
            </div>
            
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("Fonction") || "Fonction" }}
              </div>
              <b-form-input
                type="text"
                v-model="fonctionContact"
                :placeholder="$t('Fonction') || 'Fonction'"
                class="form-input custom-placeholder custom-input"
                @input="updateFonctionContact"
              />
            </div>
            
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("Téléphone") || "Téléphone" }}
              </div>
              <phone
                :tel="telephoneContact"
                @phoneNumber="formatTelephoneContact($event)"
              ></phone>
            </div>
          
          </form>
       </div>
      </div>
    
    </div>
     <!-- <div v-if="show" class="d-flex justify-content-end mt-4">
            <b-button v-if="this.visibleTabsLength<=1" @click="goToPrevStep" class="button-pre-style m-3">
        {{ $t("PREVIOUS") }}
      </b-button>
      <b-button
        type="submit"
        @click="goToStep"
        class="button-suivant-style m-3"
      >
        <template v-if="isLoading">
          <div class="loading ml-2">
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
        </template>
      
        <template >
          {{ buttonText }}
        </template>
      </b-button>
    </div> -->
    
    <div v-if="!show" class="d-flex justify-content-end mt-4">
      <b-button @click="goToPrevStep" class="button-pre-style m-3">
        {{ $t("PREVIOUS") }}
      </b-button>
      <b-button
        type="submit"
        @click="goToStep"
        class="button-suivant-style m-3"
      >
        {{ $t("NEXT") }}
        <div class="loading ml-2" v-if="isLoading">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
        <div class="loading ml-2" v-if="isLoadingButton">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
      </b-button>
    </div>
   <Snackbar ref="snackbar" />
  </div>
</template>

<script>
import { mapActions, mapGetters,mapState } from "vuex";
import domain from "@/environment";
import axios from "axios";
import Snackbar from '@/components/ui/errorSnackbar.vue';
import phone from '@/components/ui/phone.vue';
import { preventExceedingLengthFloat, handlePaste } from '@/utils/inputUtils'; 
export default {
  components: {
    Snackbar,
    phone,
  },
  props: {
  
    visibleTabsLength: {
      type: Number,
      required: true,
    },
    show: {
      type: Boolean,
      default:false,
      
    },
  
    isLoadingButton: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCompleted: false,
      errorMessage:'',
      isLoading:false,
      chauffe_eau_thermodynamiquesData: null,
      chauffe_eau_thermodynamiques: false,
      contactSurSite: null,
      fonctionContact: null,
      telephoneContact: null,


      typeInstallationOptions: [
        { value: null, text: this.$t("Sélectionnez_type"),disabled: true },
        { value: 'sur air extrait', text: this.$t("sur air extrait") },
        { value: 'autres types d’installations', text: this.$t("autres types d’installations") },
     
      ],
     
      
    };
  },
  created() {
  if (this.getdevisMonoFiche && this.getdevisMonoFiche.data) {
    this.chauffe_eau_thermodynamiquesData = this.initializechauffe_eau_thermodynamiques();
    this.initializeContactFields();
  }
},
  computed: {
  ...mapState({
    token: (state) => state.token,
  }),
  ...mapGetters(["getdevisMonoFiche"]),
  buttonText() {
      return this.visibleTabsLength <= 1 ? this.$t("NEXT") : this.$t("CONFIRMER");
    },
},

  watch: {
    getdevisMonoFiche: {
      handler(newDevis) {
        if (newDevis && newDevis.data) {
          // Préserver les valeurs locales existantes
          const currentData = this.chauffe_eau_thermodynamiquesData ? { ...this.chauffe_eau_thermodynamiquesData } : null;
          
          this.chauffe_eau_thermodynamiquesData = this.initializechauffe_eau_thermodynamiques();
          
          // Restaurer les valeurs locales si elles existent
          if (currentData) {
            Object.keys(currentData).forEach(key => {
              if (currentData[key] !== undefined && currentData[key] !== null && currentData[key] !== "") {
                this.chauffe_eau_thermodynamiquesData[key] = currentData[key];
              }
            });
          }
          
          this.chauffe_eau_thermodynamiques = newDevis.data?.devis.chauffe_eau_thermodynamiques !== null;
          this.initializeContactFields();
          if (this.chauffe_eau_thermodynamiques) {
            this.isCompleted = true;
          }
        }
      },
      deep: true,
      immediate: true,
     
  }
  },
  methods: {
    ...mapActions(["setDevisMonoFiche"]),

    onKeyDown(event) {
      preventExceedingLengthFloat(event);
    },
    
    onPaste(event, fieldName) {
      handlePaste.call(this, event, fieldName);
    },
    async postthermodynamiques(payload) {
     
        try {
          const response = await axios.post(
            domain + `/chauffe_eau_thermodynamiques`,
            payload,
            {
              headers: {
                Authorization: `Bearer ` + this.token,
              },
            }
          );
         return response.data.data
        } catch (error) {
          if (error.response && error.response.data && error.response.data.message) {
      this.errorMessage = error.response.data.message;
    } else if (error.response && error.response.data && error.response.data.errors) {
      this.errorMessage = error.response.data.errors.join(', ');
    } else {
      this.errorMessage = "Vérifiez vos données.";
    }
    this.$refs.snackbar.showSnackbar(this.errorMessage);
    return null;
        }
    },
    
    async putthermodynamiques(payload) {
     
     try {
       const response = await axios.put(
         domain + `/chauffe_eau_thermodynamiques/${payload.id}`,
         payload,
         {
           headers: {
             Authorization: `Bearer ` + this.token,
           },
         }
       );
     return response.data.data
     } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
      this.errorMessage = error.response.data.message;
    } else if (error.response && error.response.data && error.response.data.errors) {
      this.errorMessage = error.response.data.errors.join(', ');
    } else {
      this.errorMessage = "Vérifiez vos données.";
    }
    this.$refs.snackbar.showSnackbar(this.errorMessage);
    return null;
     }
 },
    initializechauffe_eau_thermodynamiques() {
      const chauffe_eau_thermodynamiques = this.getdevisMonoFiche?.data?.devis.chauffe_eau_thermodynamiques || {};
     
      return {
        id: chauffe_eau_thermodynamiques.id,
       
        cop: chauffe_eau_thermodynamiques.cop || "",
        type_installation:chauffe_eau_thermodynamiques.type_installation||"",
      
      };
    },
    async isolationAdd() {
     
      const response = await this.postthermodynamiques(this.chauffe_eau_thermodynamiquesData);
      if(response.id!==null){
      this.getdevisMonoFiche.data.devis.chauffe_eau_thermodynamiques_id = response.id;
      this.getdevisMonoFiche.data.devis.chauffe_eau_thermodynamiques = {
        id: this.getdevisMonoFiche.data.devis.chauffe_eau_thermodynamiques_id,
        cop: this.chauffe_eau_thermodynamiquesData.cop,
        type_installation:this.chauffe_eau_thermodynamiquesData.type_installation,
      };
      this.setDevisMonoFiche(this.getdevisMonoFiche);
      return response;
    }else{
         
         this.isLoading=false;
 
         return
       }
    },

    async chauffe_eau_thermodynamiquesAdd() {
     if (this.chauffe_eau_thermodynamiques) {
       
        const chauffe = {
          ...this.chauffe_eau_thermodynamiquesData,
          id: this.getdevisMonoFiche.data.devis.chauffe_eau_thermodynamiques.id,
        };
        
        const reponse = await this.putthermodynamiques(chauffe);
        this.getdevisMonoFiche.data.devis.chauffe_eau_thermodynamiques = {
          id: this.getdevisMonoFiche.data.devis.chauffe_eau_thermodynamiques.id,
        
          cop: this.chauffe_eau_thermodynamiquesData.cop,
          type_installation: this.chauffe_eau_thermodynamiquesData.type_installation,
        };

        this.setDevisMonoFiche(this.getdevisMonoFiche);
        return reponse;
      }
      await this.isolationAdd();
     
    },
    async goToStep() {
      this.isLoading=true;
      if(!this.chauffe_eau_thermodynamiquesData?.type_installation||!this.chauffe_eau_thermodynamiquesData?.cop){
          this.isLoading=false;
           this.$refs.snackbar.showSnackbar("Tous_obligatoires");
         return;
         }
      await this.chauffe_eau_thermodynamiquesAdd();
      if(this.errorMessage!==''){
     
     this.isLoading=false;
     this.$refs.snackbar.showSnackbar("Tous_obligatoires");
        this.isCompleted = false;
     return
   }
      this.isLoading=false;
      this.isCompleted = true;
      if(this.visibleTabsLength<=1){
        this.$emit("change",true);
      }else {
        this.$emit("change",false);
      }
    },
    async goToNextStep() {
      this.isLoading=true;
      if(!this.chauffe_eau_thermodynamiquesData?.type_installation||!this.chauffe_eau_thermodynamiquesData?.cop){
          this.isLoading=false;
           this.$refs.snackbar.showSnackbar("Tous_obligatoires");
         return;
         }
      await this.chauffe_eau_thermodynamiquesAdd();
      if(this.errorMessage!==''){
     
     this.isLoading=false;
   
     return
   }
      this.isLoading=false;
      this.$emit("changeStep", 5, true);
    },
    goToPrevStep() {
      if(this.visibleTabsLength<=1){
        this.$emit("changePrev",true);
      }else {
        this.$emit("changePrev",false);
      }
      this.$emit("changeStep", 3);
    },
    initializeContactFields() {
      const devis = this.getdevisMonoFiche?.data?.devis;
      this.contactSurSite = devis?.contact_sur_site || null;
      this.fonctionContact = devis?.fonction_contact || null;
      this.telephoneContact = devis?.telephone_contact || null;
    },
    updateContactSurSite() {
      this.getdevisMonoFiche.data.devis.contact_sur_site = this.contactSurSite || null;
      this.setDevisMonoFiche(this.getdevisMonoFiche);
    },
    updateFonctionContact() {
      this.getdevisMonoFiche.data.devis.fonction_contact = this.fonctionContact || null;
      this.setDevisMonoFiche(this.getdevisMonoFiche);
    },
    formatTelephoneContact(event) {
      if (event && event.number && event.country) {
        this.telephoneContact = {
          phone_number: event.number,
          phone_iso_code: event.country.iso2,
          formated_phone: event.formatted || null,
        };
        this.getdevisMonoFiche.data.devis.telephone_contact = this.telephoneContact;
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      } else if (!event || !event.number) {
        this.telephoneContact = null;
        this.getdevisMonoFiche.data.devis.telephone_contact = null;
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      }
    },
  },
};
</script>
<style scoped>
.custom-placeholder::placeholder {
  font-size: 13px;
}
.form-input {
  font-size: 13px;
  height: 41.1px !important;
}
.borderPointier {
  border: 2px dashed #24316d;
  position: relative;
}
.input-style {
  margin-bottom: 1rem;
  border-radius: 4px;
  border: 1px solid #eaebec;
  padding: 0.5rem 0.75rem;
  background-color: #fff;
}

.background-white {
  display: inline-block;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  position: absolute;
  top: -1rem;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: center;
}
.title {
  color: #24316d;
  position: relative;
  z-index: 2;
  margin: 0;
}

.position {
  background-color: white;
  display: inline-block;
  padding: 0.05rem 2rem;
}
.custom-input {
  box-shadow: none;
}
.small-spinner .spinner-border {
  width: 1rem;
  height: 1rem;
}
</style>
